SlotsEngine = {
  types: {},
  instantiators: {},
};

SlotsEngine.types.ReelSpinnerVisual = require("./SlotMachineEx/ReelVisuals/ReelSpinnerVisual.js");
SlotsEngine.instantiators.SymbolRule = require("./SlotMachineEx/SymbolRules/SymbolRules.js");
require("./SlotMachineEx/SymbolRules/DistanceRules.js");
require("./SlotMachineEx/SymbolRules/GroupRules.js");
require("./SlotMachineEx/SlotMachine.js");
require("./WinAnimationEx/SymbolAnimators/LowSymbolAnimator.js");
require("./WinAnimationEx/SymbolAnimators/SpineSymbolAnimator.js");
require("./WinAnimationEx/SymbolAnimators/SymbolAnimator.js");
require("./WinAnimationEx/WinController.js");
require("./WinAnimationEx/winlineAnimator.js");
require("./WinAnimationEx/Batchers/WinBatcherGroupedSymbols.js");
require("./WinAnimationEx/Batchers/WinlineBatcherAllAtOnce.js");
require("./WinAnimationEx/Batchers/WinlineBatcherAllAtOnceThenIndividual.js");
require("./WinAnimationEx/StandardWinCounter.js");
require("./SlotMachineEx/AnticipationAnalysisScatter.js");
